import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { CustomFieldValueDefinition } from '@alucio/aws-beacon-amplify/src/models';
import { DNABox, DNAText } from '@alucio/lux-ui';
import { DNAChip, DNAPopover } from 'src/components/DNA';
import { DocumentVersionORM } from 'src/types/orms';

interface DNACustomFieldChipProps {
  badge: CustomFieldValueDefinition,
}
interface DNACustomFieldChipListProp {
  documentVersionORM?: DocumentVersionORM;
  style?: StyleProp<ViewStyle>;
}

export const DNACustomFieldChip: React.FC<DNACustomFieldChipProps> = (props) => {
  const { badge } = props;

  if (!badge.badgeColor && !badge.badgeLabel) {
    return null;
  }

  return (
    <DNAPopover placement="top" disablePopover={['tabletPWA']}>
      <DNAPopover.Anchor>
        <DNAChip.Beacon
          testID="chip-purpose-type"
          style={{ borderColor: badge.badgeColor, color: badge.badgeColor }}
        >
          {badge.badgeLabel}
        </DNAChip.Beacon>
      </DNAPopover.Anchor>
      <DNAPopover.Content offset={2}>
        <DNAText colorMode="dark">
          {badge.value}
        </DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export const DNACustomFieldChipList: React.FC<DNACustomFieldChipListProp> = (props) => {
  const { documentVersionORM, style } = props;

  if (!documentVersionORM?.meta.badges) {
    return null;
  }

  return (
    <DNABox spacing="sm" style={style}>
      {documentVersionORM.meta.badges.map((badge) =>
        <DNACustomFieldChip key={badge.id} badge={badge} />)}
    </DNABox>
  )
}

export default DNACustomFieldChipList;
